const {
  beforeBreadcrumb,
  beforeSend,
  beforeSendTransaction,
  isStaleChunkLoadError,
} = require("./_filters.cjs");

/**
 * Options to spread into a browser/server Sentry.init call (e.g. @sentry/nextjs).
 * Keeps expected-noise filtering in @pima/observability rather than in each app.
 *
 * @param {Record<string, unknown>} [overrides]
 */
function browserObservabilityOptions(overrides = {}) {
  return {
    sendDefaultPii: false,
    beforeSend,
    beforeSendTransaction,
    beforeBreadcrumb,
    ...overrides,
  };
}

module.exports = {
  browserObservabilityOptions,
  isStaleChunkLoadError,
};
